import React from "react";
import MusicForm from "../components/MusicForm";

const Upload: React.FC = () => {
  return <MusicForm />;
};

export default Upload;
